import Vue from 'vue'
import Antd from 'ant-design-vue'
import "ant-design-vue/dist/antd.css"

Vue.use(Antd)


// WEBPACK FOOTER //
// ./src/useComponents.js